module.exports = __webpack_public_path__ + "media/packages/copies-e1310c92.svg";